export const SITE_ORIGIN = 'https://hmonglusapp.com';
export const OG_IMAGE_PATH = '/og-image.png';
export const OG_IMAGE_URL = `${SITE_ORIGIN}${OG_IMAGE_PATH}`;
export const LLMS_TXT_URL = `${SITE_ORIGIN}/llms.txt`;

export function siteUrl(path: string): string {
  if (!path || path === '/') return `${SITE_ORIGIN}/`;
  return `${SITE_ORIGIN}${path.startsWith('/') ? path : `/${path}`}`;
}
